import { Alert, Snackbar } from '@mui/material';
import React, { useContext } from 'react';
import UIContext from '../Context.js/UIContext';

const SnackBar = () => {
  const { showSnackBar, closeSnackBar, alterType, alterMessage } =
    useContext(UIContext);
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={showSnackBar}
      autoHideDuration={2000}
      onClose={closeSnackBar}
    >
      <Alert onClose={closeSnackBar} severity={alterType}>
        {alterMessage}
      </Alert>
    </Snackbar>
  );
};

export default SnackBar;
